export default __webpack_public_path__ + "static/media/Drag.18baf2469bac8dc6dcc75d57862a0bf4.svg";